/**
 * Created by noOne on 27/10/2017.
 */
"use strict";

import GlitchFilter from "./GlitchFilter";

/**
 * @class
 */
export default class ScoreManager {
    /**
     * @param scorePanel {PIXI.Sprite}
     * @param bulletPanel {PIXI.Sprite}
     * @param meter {PIXI.Sprite}
     * @param gameOver {Function}
     * @param cb {Function}
     */
    constructor(scorePanel, bulletPanel, meter, gameOver, cb) {

        /**
         * @type {null[]}
         */
        this.healthTweens = [null, null];

        /**
         * @type {function}
         */
        this.cb = cb;

        /**
         * @type {Number}
         * @private
         */
        this._meterStart = meter.x;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._scorePanel = scorePanel;

        /**
         * @type {PIXI.Text}
         * @private
         */
        this._scoreView = scorePanel.scoreView;

        /**
         * @type {PIXI.Text}
         * @private
         */
        this._multiView = scorePanel.multiView;

        /**
         * @type {number}
         * @private
         */
        this._score = 0;

        /**
         * @type {number}
         * @private
         */
        this._multiplier = 1;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._meter = meter;

        /**
         * @type {Function}
         * @private
         */
        this._gameOver = gameOver;

        /**
         * @type {number}
         * @private
         */
        this._highestMulti = -1;

        /**
         * @type {PixelGlitchFilter}
         * @private
         */
        this._glitchFilter = new GlitchFilter(25);

        /**
         * @type {GlowFilter}
         * @private
         */
        this._glowFilter = new PIXI.filters.GlowFilter(10, 0, 0, 0xfa52a5, 0.1);

        /**
         * @type {number}
         * @private
         */
        this._bulletsMax = 8;

        /**
         * @type {number}
         * @private
         */
        this._bullets = this._bulletsMax;

        /**
         * @type {*|PIXI.Sprite}
         * @private
         */
        this._bulletPanel = bulletPanel;

        /**
         * @type {Array}
         * @private
         */
        this._bulletIndicators = [];

        /**
         * @type {Array}
         * @private
         */
        this._bulletBacks = [];

        /**
         * @type {boolean}
         * @private
         */
        this._lightningFlipFlop = false;

        this._initBulletView();
    }

    /**
     * @private
     */
    _initBulletView() {

        this._bulletPanel.anchor.set(0, 0.5);
        this._bulletPanel.back1.anchor.set(0, 0.5);
        this._bulletPanel.back2.anchor.set(0, 0.5);

        const refillBtn = this._refillBtn = P3.simpleButton("reload", null, ()=> {
            // pointless btn does nothing just for look
        }, this);
        this._bulletPanel.addChild(refillBtn);
        refillBtn.x = 140;
        refillBtn.y = 215;

        const texture = Common.assets.texture("ammo_loading_on");
        //  let xSpace = 0, ySpace = 0;
        for (let i = 0; i < this._bullets; i++) {

            let bk = P3.createSprite(Common.assets.texture("ammo_loading_off"), this._bulletPanel);
            bk.y = i * 25.5 - 70;
            bk.x = 83;
            this._bulletBacks.push(bk);

            let sp = P3.createSprite(texture, this._bulletPanel);
            sp.y = i * 25.5 - 70;
            sp.x = 83;
            this._bulletIndicators.push(sp);
        }
        this._bulletIndicators.reverse();//reverse array so bullets refill in opposite order

        this._bulletPanel.interactive = true;
        this._bulletPanel.mousedown = this._bulletPanel.touchstart = this.refillBullets.bind(this);

        this._animatingPanel = true;
        const oldPos = new PIXI.Point(this._bulletPanel.x, this._bulletPanel.y);
        this._bulletPanel.x -= 275;
        this._bulletPanel.back1.x -= 275;
        this._bulletPanel.back2.x -= 275;

        this._bulletPanel.startScale = new PIXI.Point(this._bulletPanel.scale.x, this._bulletPanel.scale.y);

        TweenMax.to(this._bulletPanel, 0.3, {
            x: oldPos.x,
            delay: 1.1,
            ease: Back.easeOut,
            onComplete: ()=> {
                this._animatingPanel = false;
            }
        });

        TweenMax.to(this._bulletPanel.back1, 0.3, {
            x: oldPos.x,
            delay: 1.2,
            ease: Power1.easeOut,
            onComplete: ()=> {
                this._animatingPanel = false;
            }
        });

        TweenMax.to(this._bulletPanel.back2, 0.3, {
            x: oldPos.x,
            delay: 1.3,
            ease: Power1.easeOut,
            onComplete: ()=> {
                this._animatingPanel = false;
            }
        });

    }

    update() {
        this._scoreView.text = "" + this._score;
    }

    resize() {
        if (this._animatingPanel) return;
        this._bulletPanel.x = (Common.STAGE_WIDTH - P3.View.width) * 0.5 - 35;
        this._bulletPanel.back1.x = this._bulletPanel.back2.x = this._bulletPanel.x;
    }

    getHitValue() {
        return this._multiplier * 3;
    }

    /**
     * @public
     */
    addScore() {
        const hitValue = this.getHitValue();
        let obj = {value: this._score};
        TweenMax.to(obj, hitValue * 0.05, {
            value: this._score + hitValue, ease: Power0.easeNone, onUpdate: ()=> {
                this._score = Math.floor(obj.value);
            }, onComplete: ()=> {
                this._score = this._score + hitValue;
            }
        });
    }

    /**
     * @public
     */
    addMultiplier() {
        //create a new paper sheet and animate
        const paper = P3.createSprite("multiplier_sheet");
        paper.position = Common.getMultiPanelPos();

        paper.textView = createText("" + this._multiplier, {size: 31, fill: 0x644727});
        paper.textView.y = 3;
        paper.textView.x = -3;
        paper.textView.anchor.set(0.5, 0.5);

        paper.addChild(paper.textView);
        Common.uiLayer.addChild(paper);

        paper.anchor.set(0.5, 0.5);

        paper.rotation = Math.PI / 4 * ((Math.random() * 2) - 1);

        const t = 2;
        TweenMax.to(paper, t, {
            rotation: paper.rotation + Math.PI * 2,
            ease: Power0.easeNone
        });
        TweenMax.to(paper, t * 0.25, {
            x: paper.x + 25,
            yoyo: true,
            repeat: 3,
            ease: Power1.easeInOut,
            yoyoEase: Power1.easeInOut
        });
        TweenMax.to(paper, t, {
            alpha: 0,
            y: paper.y + 175,
            ease: Power0.easeNone,
            onComplete: ()=> {
                paper.destroy();
            }
        });

        TweenMax.to(paper, t * 0.75, {
            alpha: 0,
            ease: Power0.easeNone
        });

        this._multiplier++;
        this._multiView.text = "" + this._multiplier;

        if (this._multiplier > this._highestMulti) this._highestMulti = this._multiplier;

        //animate multiplier panel
        const multiPanel = this._scorePanel.multiPanel;
        multiPanel.scale.y = 0;
        TweenMax.to(multiPanel.scale, 0.1, {y: 1, ease: Power0.easeNone});
    }

    /**
     * @public
     */
    resetMultiplier() {

        this._multiplier = 1;
        this._multiView.text = "" + this._multiplier;

        //animate multiplier panel
        const multiPanel = this._scorePanel.multiPanel;
        multiPanel.filters = [this._glowFilter];
        TweenMax.to(this._glowFilter.uniforms, 0.2, {
            outerStrength: 5,
            yoyo: true,
            repeat: 1,
            onComplete: ()=> {
                multiPanel.filters = null;
            }
        });

    }

    /**
     * @public
     */
    hitPlayer() {

        let xTarg = this._meter.x - Common.barMaxFill / 3;
        let xTarg2 = xTarg + Common.barMaxFill;

        this.healthTweens[0] = TweenMax.to(this._meter, 0.15, {ease: Power0.easeNone, x: xTarg});
        this.healthTweens[1] = TweenMax.to(this._meter.barEnd, 0.15, {ease: Power0.easeNone, x: xTarg2});

        if (xTarg < -531.25) this._gameOver();

        this._meter.panel.filters = [this._glitchFilter];
        this._scorePanel.filters = [this._glitchFilter];
        this._bulletPanel.filters = [this._glitchFilter];

        delay(()=> {
            this._meter.panel.filters = null;
            this._scorePanel.filters = null;
            this._bulletPanel.filters = null;
        }, 0.15, this);

        //Common.erraticTween(Common.world, 0.05, {y: 5, x: 35, yoyo: true, repeat: 3});
        Common.cameraShake.trauma += 0.5;

        Common.audio.playSound("sfx_playerhit");
    }

    refillHealth() {
        if (this._meter.x < this._meterStart) {

            let xTarg = this._meter.x + Common.barMaxFill / 3;
            let xTarg2 = xTarg + Common.barMaxFill;

            if (xTarg2 > 270) xTarg2 = 270;//some crappy hacks to get the end of the bar fill in the correct place

            TweenMax.to(this._meter, 0.15, {ease: Power0.easeNone, x: xTarg});
            TweenMax.to(this._meter.barEnd, 0.15, {ease: Power0.easeNone, x: xTarg2});

        }
    }

    /**
     * @public
     */
    useBullet() {

        if (!this.gotBullets()) return;

        this._bullets--;
        this._bulletIndicators[this._bullets].visible = false;

        if (!this.gotBullets()) {
            Common.audio.playSound("sfx_empty_00");
            this._bulletPanel.reloadText.visible = true;

            this._bulletPanel.reloadText.rotation = -Math.PI * 0.05;
            this._reloadTextTween = TweenMax.to(this._bulletPanel.reloadText, 0.3, {
                rotation: Math.PI * 0.05,
                yoyo: true,
                repeat: -1,
                ease: Power0.easeNone,
                onRepeat: ()=> {
                    if (!this._lightningFlipFlop) {
                        this._bulletPanel.reloadText.lLight.texture = Common.assets.texture("reload_warning_002");
                        this._bulletPanel.reloadText.rLight.texture = Common.assets.texture("reload_warning_002");
                    } else {
                        this._bulletPanel.reloadText.lLight.texture = Common.assets.texture("reload_warning_001");
                        this._bulletPanel.reloadText.rLight.texture = Common.assets.texture("reload_warning_001");
                    }
                    this._lightningFlipFlop = !this._lightningFlipFlop;
                }
            });

            let flag = true;
            if (!this._reloadTween) {
                this._reloadTween = TweenMax.to(this._bulletPanel.scale, 0.3, {
                    x: 1,
                    y: 1,
                    yoyo: true,
                    repeat: -1,
                    onRepeat: ()=> {
                        flag = !flag;
                        if (flag) {
                            for (let i = 0; i < this._bulletBacks.length; i++) {
                                this._bulletBacks[i].tint = 0xff0000;
                            }
                        }
                        else {
                            for (let i = 0; i < this._bulletBacks.length; i++) {
                                this._bulletBacks[i].tint = 0xffffff;
                            }
                        }
                    }
                });
            }
        }

    }

    /**
     * @public
     */
    refillBullets() {
        for (let i = this._bullets; i < this._bulletsMax; i++) {
            const bi = this._bulletIndicators[i];
            if (!bi) continue; //why?
            if (bi.visible) {
                console.warn("bullet shouldn't be visible");
                continue;
            }
            bi.scale.set(0);
            bi.visible = true;
            TweenMax.to(bi.scale, 0.35, {x: 1, y: 1, ease: Back.easeOut, delay: 0.1 * (i - this._bullets)});
        }
        this._bullets = this._bulletsMax;

        if (this._reloadTween) {
            this._reloadTween.kill();
            this._reloadTween = null;
            this._bulletPanel.scale.set(this._bulletPanel.startScale.x, this._bulletPanel.startScale.y);
        }

        Common.audio.playSound("sfx_reload_00");
        this._refillBtn.visible = true;

        this.cb.onReload();

        if (this._onRefillTutComplete) {
            this._onRefillTutComplete();
            this._onRefillTutComplete = null;//callback function and remove (do once)
        }

        for (let i = 0; i < this._bulletBacks.length; i++) {
            this._bulletBacks[i].tint = 0xffffff;
        }

        this._bulletPanel.reloadText.visible = false;

        if (this._reloadTextTween) this._reloadTextTween.kill();
        this._reloadTextTween = null;
    }

    /**
     * @public
     */
    gotBullets() {
        if (this._bullets < 1) {
            Common.audio.playSound("sfx_linealert");
            this.cb.onEmpty();
        }
        return (this._bullets > 0);
    }

    get score() {
        return this._score;
    }

    get highestMultiplier() {
        return this._multiplier;
    }

    set onRefillTutComplete(value) {
        this._onRefillTutComplete = value;
    }
}